import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProfitCenters } from '../../redux/actions/Settings/InventorySetup/profitCenterAction';

const useProfitCenters = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getProfitCenters());
    }, [dispatch]);
    let { profitCenterDropdown, allProfitCenters, parentProfitCenterDropdown } = useSelector((state) => state.profitCenter);
    return { profitCenterDropdown, allProfitCenters, parentProfitCenterDropdown };
};

export default useProfitCenters;
